<template>
  <div class="container">
    <loading-component v-if="isLoading" />
    <div v-else-if="competitionManagement == null">
      <section class="section">
        <div class="container">
          <h1 class="title">{{this.$appName}} Manager</h1>
          <h2 class="subtitle">Authorizing...</h2>
        </div>
      </section>
    </div>
    <div v-else>
      <section class="section">
        <div class="container">
          <h1 class="title">{{this.$appName}} Manager</h1>
          <h2 class="subtitle">{{competitionManagement.name}}</h2>

          <p>
            <strong>Open until:</strong>
            {{formatDateTime(competitionManagement.openTo)}}
          </p>
          <p>
            <strong>Current state:&nbsp;</strong>
            <span v-if="competitionManagement.isOpen">Open</span>
            <span v-else>Closed</span>
          </p>
          <p>
            <strong>Number of visitors:</strong>
            {{competitionManagement.numberOfVisitors}}
          </p>
          <p>
            <strong>Votes placed:</strong>
            {{competitionManagement.numberOfVotees}}
          </p>
          <p>
            <strong>Vote percentage:</strong>
            {{votePercentage}}%
          </p>
        </div>
      </section>

      <section>
        <div class="container">
          <div class="buttons admin-buttons" style="display:block !important">
            <div class="button-container">
              <b-button
                icon-left="email-outline"
                v-on:click="confirmSendInvites"
                class="button is-danger"
              >Send invites</b-button>
            </div>
  <div class="button-container">
              <b-button
                icon-left="vote"
                v-on:click="displayWelcomeTexts"
                class="button is-info"
              >Display welcome texts</b-button>
            </div>
            <div v-if="competitionManagement.isOpen" class="button-container">
              <b-button
                icon-left="stop-circle-outline"
                v-on:click="confirmCloseCompetition"
                class="button is-danger"
              >Close competition</b-button>
            </div>
            <div v-else class="button-container">
              <b-button
                icon-left="play-circle-outline"
                v-on:click="confirmOpenCompetition"
                class="button is-success"
              >Open competition</b-button>
            </div>
            <div v-if="competitionManagement.isResultPublished" class="button-container">
              <b-button
                icon-left="eye-off-outline"
                v-on:click="confirmUnpublishResult"
                class="button is-danger"
              >Unpublish result</b-button>
            </div>
            <div v-else class="button-container">
              <b-button
                icon-left="eye-outline"
                v-on:click="confirmPublishResult"
                class="button is-success"
                :disabled="competitionManagement.isOpen"
              >Publish result</b-button>
            </div>
            <div class="button-container">
              <b-button
                icon-left="counter"
                v-on:click="confirmForceResult"
                class="button is-info"
              >Force vote count</b-button>
            </div>
            <div class="button-container">
              <b-button
                icon-left="eye-outline"
                v-on:click="displayEarlyResult"
                class="button is-info"
              >Display early result</b-button>
            </div>
            <div class="button-container">
              <b-button
                icon-left="vote"
                v-on:click="displayVotesList"
                class="button is-info"
              >Display votes list</b-button>
            </div>
            <div v-if="competitionManagement.brewersChoiceVotingEnabled" class="button-container">
              <b-button
                icon-left="trophy"
                v-on:click="displayBrewersChoiceResult"
                class="button is-info"
              >Get Brewer's Choice Result</b-button>
            </div>
            <div v-if="competitionManagement.isCurrent" class="button-container">
              <b-button
                icon-left="stop-circle-outline"
                v-on:click="confirmArchiveCompetition"
                class="button is-danger"
              >Archive competition</b-button>
            </div>
            <div v-if="competitionManagement.isCurrent" class="button-container">
                <b-button icon-left="stop-circle-outline"
                v-on:click="confirmDeleteBrew"
                class="button is-danger">Delete brew</b-button>
            </div>
            <div v-if="competitionManagement.isCurrent" class="button-container">
                <b-button icon-left="file-pdf-box"
                v-on:click="promptShowDisplayHtmlOneBrew"
                class="button is-info">Get Print HTML (One)</b-button>
            </div>
            <div v-if="competitionManagement.isCurrent" class="button-container">
                <b-button icon-left="file-pdf-box"
                v-on:click="promptShowDisplayHtmlAllBrews"
                class="button is-info">Get Print HTML (All)</b-button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import apiService from "./../services/apiService";
import LoadingComponent from "./Loading.vue";
import { Dialog } from "buefy";
var moment = require("moment");
moment().format();
export default {
  name: "Manager",
  components: {
    LoadingComponent
  },
  props: {
    competitionId: String,
    apiKey: String
  },

  data() {
    return {
      isLoading: false,
      competitionManagement: null
    };
  },

  async created() {
    await this.refreshManager();
  },

  computed: {
    votePercentage() {
      return Math.floor(
        (this.competitionManagement.numberOfVotees /
          this.competitionManagement.numberOfVisitors) *
          100
      );
    }
  },

  methods: {
    formatDateTime(datetime) {
      return moment(datetime).format("YYYY-MM-DD HH:mm:ss");
    },

    async refreshManager() {
      this.isLoading = true;
      try {
        await this.fetchCompetition();
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },

    getToken() {
      var managerToken = {
        competitionId: this.competitionId,
        apiKey: this.apiKey
      };
      return managerToken;
    },

    displayVotesList: function(event) {
      this.$router.push({
        name: "votessummary",
        params: {
          competitionId: this.competitionManagement.id,
          competitionName: this.competitionManagement.name,
          apiKey: this.apiKey
        }
      });
    },

    displayBrewersChoiceResult: function(event) {
      this.$router.push({
        name: "brewerschoiceresult",
        params: {
          competitionId: this.competitionManagement.id,
          competitionName: this.competitionManagement.name,
          apiKey: this.apiKey
        }
      });
    },

    displayWelcomeTexts: function(event) {
      this.$dialog.prompt({
        title: "Customize Welcome Text",
        message: "What should come after 'Välkommen till Norrlands Hembryggarträff'?",
        inputAttrs: {
          type: "text",
          placeholder: "e.g., hösten 2025",
          value: "hösten 2025"
        },
        onConfirm: (welcomeTextSuffix) => {
          this.$dialog.prompt({
            title: "Customize Theme",
            message: "What theme should be displayed?",
            inputAttrs: {
              type: "text",
              placeholder: "e.g., Asien",
              value: "Asien"
            },
            onConfirm: (theme) => {
              this.$router.push({
                name: "welcometexts",
                params: {
                  competitionId: this.competitionManagement.id,
                  competitionName: this.competitionManagement.name,
                  apiKey: this.apiKey,
                  welcomeTextSuffix: welcomeTextSuffix,
                  theme: theme
                }
              });
            }
          });
        }
      });
    },
    

    displayEarlyResult: function(event) {
      var self = this;

      this.$router.push({
        name: "competitionresults",
        params: {
          competitionId: this.competitionManagement.id,
          competitionName: this.competitionManagement.name,
          classes: this.competitionManagement.classes,
          apiKey: this.apiKey
        }
      });
    },

    showErrorToaster(msg) {
      this.$toast.open({
        message: msg,
        type: "is-error",
        position: "is-bottom"
      });
    },

    showSuccessToaster(msg) {
      this.$toast.open({
        message: msg,
        type: "is-success",
        position: "is-bottom"
      });
    },

    async confirmSendInvites() {
      this.$dialog.confirm({
        message: "Send invites?",
        onConfirm: async () => await this.sendInvites()
      });
    },

    async sendInvites() {
      var self = this;

      var token = this.getToken();
      try {
        await apiService.sendInvites(token);
        this.showSuccessToaster("Invites sent!");
      } catch (err) {
        this.showErrorToaster(err.response.data);
      }
    },

    async confirmForceResult() {
      this.$dialog.confirm({
        message: "Force result?",
        onConfirm: async () => await this.forceResult()
      });
    },

    async forceResult() {
      var self = this;

      var token = this.getToken();
      apiService
        .forceCompetitionResult(token)
        .then(response => {
          this.showSuccessToaster("Force result succeeded!");
        })

        .catch(err => {
          this.showErrorToaster(err.response.data);
        });
    },
    async confirmOpenCompetition() {
      this.$dialog.confirm({
        message: "Open competition?",
        onConfirm: async () => await this.openCompetition()
      });
    },
    async openCompetition() {
      var self = this;

      var token = this.getToken();
      try {
        await apiService.openCompetition(token);
        this.showSuccessToaster("Open competition succeeded!");

        await this.refreshManager();
      } catch (err) {
        this.showErrorToaster(err.response.data);
      }
    },

    async confirmCloseCompetition() {
      this.$dialog.confirm({
        message: "Close competition?",
        onConfirm: async () => await this.closeCompetition()
      });
    },

    async closeCompetition() {
      var self = this;

      var token = this.getToken();
      try {
        await apiService.closeCompetition(token);
        this.showSuccessToaster("Close competition succeeded!");

        await this.refreshManager();
      } catch (err) {
        this.showErrorToaster(err.response.data);
      }
    },

    async confirmPublishResult() {
      this.$dialog.confirm({
        message: "Publish result?",
        onConfirm: async () => await this.publishResult()
      });
    },

    async publishResult() {
      var token = this.getToken();
      try {
        await apiService.publishCompetitionResult(token);
        this.showSuccessToaster("Publish result succeeded!");

        await this.refreshManager();
      } catch (err) {
        this.showErrorToaster(err.response.data);
      }
    },

    async confirmUnpublishResult() {
      this.$dialog.confirm({
        message: "Unpublish result?",
        onConfirm: async () => await this.unpublishResult()
      });
    },

    async unpublishResult() {
      var token = this.getToken();
      try {
        await apiService.unpublishCompetitionResult(token);
        this.showSuccessToaster("Unpublish result succeeded!");

        await this.refreshManager();
      } catch (err) {
        this.showErrorToaster(err.response.data);
      }
    },

    async confirmArchiveCompetition() {
      this.$dialog.confirm({
        message: "Archive competition?",
        onConfirm: async () => await this.archiveCompetition()
      });
    },

    async confirmDeleteBrew() {
      this.$dialog.prompt({
        message: "Delete brew?",
        inputAttrs: {
          type: "text",
          placeholder: "Enter brew ID",
          required: true
        },
        onConfirm: async (brewId) => await this.deleteBrew(brewId)
      });
    },

    async promptShowDisplayHtmlOneBrew() {
        this.$dialog.prompt({
            message: "Show Display HTML",
            inputAttrs: {
                type: "text",
                placeholder: "Enter brew display number"
            },
            onConfirm: async (displayNumber) => await this.showDisplayHtml(displayNumber)
        });
    },

    async promptShowDisplayHtmlAllBrews() {
        this.$dialog.prompt({
            message: "Show Display HTML",
            hasInput: false,
            onConfirm: async () => await this.showDisplayHtml()
        });
    },

    async showDisplayHtml(displayNumber) {
        if (this.isLoadingHtml) {
            return;
        }

        this.isLoadingHtml = true;
        try {
            // Get HTML content from the backend
            const response = await apiService.getBrewDisplayHtml(this.competitionManagement.id, displayNumber);

            // Create a new window
            const newWindow = window.open('', '_blank');
            if (newWindow) {
                // Write the HTML content directly to the new window
                newWindow.document.write(response.data);
                newWindow.document.close();
                this.showSuccessToaster('Display HTML opened in a new tab!');
            } else {
                this.showErrorToaster('Unable to open new window. Please check your popup settings.');
            }
        } catch (err) {
            console.error(err);
            const errorMessage = err.response && err.response.data
                ? err.response.data
                : 'Error getting HTML content';
            this.showErrorToaster(errorMessage);
        } finally {
            this.isLoadingHtml = false;
        }
    },

    async archiveCompetition() {
      var token = this.getToken();
      try {
        await apiService.archiveCompetition(token);
        this.showSuccessToaster("Archive competition succeeded!");

        await this.refreshManager();
      } catch (err) {
        this.showErrorToaster(err.response.data);
      }
    },

    async deleteBrew(brewId) {
      var self = this;
      var token = this.getToken();
      try {
        await apiService.deleteBrew(token, brewId);
        this.showSuccessToaster("Brew deleted!");
        await this.refreshManager();
      } catch (err) {
        this.showErrorToaster(err.response.data);
      }
    },

    async fetchCompetition() {
      var self = this;
      var managerToken = {
        competitionId: this.competitionId,
        apiKey: this.apiKey
      };

      apiService
        .getCompetitionManagement(managerToken)
        .then(response => {
          this.showSuccessToaster("Authorized");
          self.competitionManagement = response.data;
        })
        .catch(err => {
          this.showErrorToaster(err.response.data);
        });
    }
  }
};
</script>
